module.exports = __webpack_public_path__ + "media/images/mark-4abb4fd14497fe52d023fd29249a7d5c.gif";